<div class="modal-header" style="justify-self:flex-start ">
  <h1 class="modal-title text-center">Connection in progress</h1>
</div>
<div class="modal-body d-flex flex-row justify-content-center">
  <span>
    @if (reconnectionMessage$ | async; as message) {
      {{message}}
    } @else {
      <span aria-hidden="true">Waiting ...</span>
    }

  </span>
</div>
<div class="modal-footer d-flex justify-content-center">
  <button (click)="retry()" [disabled]="retryButtonDisabled$ | async" class="btn btn-primary" type="button">Retry
    now
  </button>
</div>
